import React from 'react';

const Home = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Welcome to Mind Mesch</h1>
      <p>This is your home base for API access, partner tools, and usage insights.</p>
    </div>
  );
};

export default Home;
